import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@volca/ui/components/ui/stack";
import type { EnrichedProfitabilityPeriod } from "@/profitability/types";
export const requestedCol: ColumnDef<EnrichedProfitabilityPeriod> = {
  id: "created_at",
  header: "Requested",
  accessorFn: (row) => row.created_at,
  meta: { size: "200px" },
  // Who asked only matters next to when, and at most businesses it is the
  // same person every time, so it rides along rather than taking a column.
  cell: ({ row }) => (
    <Stack align="start" gap={0}>
      <span className="text-subtle">{row.original.display.requestedAt}</span>
      {/* Most reports finish within the minute they were asked for, and the
          same time twice says nothing. */}
      {row.original.display.completedAt &&
        row.original.display.completedAt !==
          row.original.display.requestedAt && (
          <span className="text-xs text-subtle">
            Completed {row.original.display.completedAt}
          </span>
        )}
      <span className="text-xs text-subtle">
        {row.original.requester.full_name}
      </span>
    </Stack>
  ),
};
